<button class="action" (click)="toggle()"
        [ngClass]="{'mobile': navigationService.useMobileNav$ | async, 'active':active, 'disabled': disabled}">
    <div class="action-media">
        <fui-icon class="action-media-object" [icon]="'hamburger'" [width]="19" [height]="19"></fui-icon>
    </div>
</button>
